














































































































import {
  ComponentInternalInstance,
  computed,
  ComputedRef,
  defineComponent,
  getCurrentInstance,
  ref,
  watch,
} from '@vue/composition-api';

import Meeting from '@/renderer/components/meeting/index.vue';
import ElectronSign from '@/renderer/views/desktop/headbar/components/ElectronicSignPopup/index.vue';
import FileApplyDialog from '@/renderer/components/dialog/FileApply/components/FileApplyDialog.vue';

// 引入 compositions
import { PreviewHandler } from '@/renderer/views/preview/compositions/previewHandler';
import { QueryFrom } from '@/renderer/views/preview/compositions/previewHandlerInterface';

// 引入工具类
import { i18n_t } from '@/locales/i18n';
import { CONSTANT_URL } from '@/renderer/scripts/http';
import { CollaborateGroupEvents } from '@/renderer/store/modules/collaborateGroup';
import { checkToNumber } from '@/renderer/scripts/utils/tools';

import baseHeadbarHandler from '../composition/baseHeadbarHandler';

export default defineComponent({
  components: {
    ElectronSign,
    Meeting,
    FileApplyDialog,
  },
  props: {
    previewHandler: {
      type: Object as () => PreviewHandler,
      required: true,
    },
  },
  setup(props, context) {
    const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const { previewHandler } = props;
    const fileApplied = ref<boolean>(false);
    const currentFileList = computed(() =>
      previewHandler.currentFile.value ? [previewHandler.currentFile.value] : [],
    );
    const fileName: ComputedRef<string> = computed(() => previewHandler.currentFile.value?.name ?? '');
    const ext = computed(() => (fileName.value && fileName.value.slice(fileName.value.lastIndexOf('.') + 1)) || '');
    const { envHelp, goToIndexPage } = baseHeadbarHandler();
    const renderBar = computed(() => {
      const { isCustomizedDomain } = CONSTANT_URL;
      const { isInWeMeetApp, isLogined, isTclApp, isBrowser } = vm.$store.getters;
      const currFileInfo = previewHandler.spaceTag;
      return {
        homeIcon:
          isBrowser &&
          ((!isInWeMeetApp && isLogined) || (isInWeMeetApp && !isLogined)) &&
          ((!isTclApp && isLogined) || (isTclApp && !isLogined)),
        dividerLeft: isBrowser && !isInWeMeetApp && isLogined && !isTclApp,
        returnIcon: !isBrowser || (isInWeMeetApp && isLogined) || (isTclApp && isLogined),
        envHelp: !!envHelp.value,
        dividerRight: isLogined,
        meeting: !isInWeMeetApp && isLogined && !isCustomizedDomain && !vm.$store.getters.isPrivate,
        /**
         * 判断是否显示电子签：
         * 1、来源其他路由：根据spaceTag === 'team'
         * 2、直接来源电子签路由
         */
        esign:
          ['pdf', 'doc', 'docx'].includes(ext.value.toLowerCase()) &&
          ((currFileInfo && currFileInfo === 'team') ||
            (vm.$route.query?.from && vm.$route.query?.from === 'electronicSign')) &&
          !vm.$store.getters.isPrivate,
        dropdownOperate: previewHandler.queryFrom.value !== QueryFrom.Share,
      };
    });
    const headerHandler = previewHandler.headerActionHandler;
    if (!headerHandler) return {};

    // loganylwu 之所以不合并到previewHeaderActionHandler中，是因为我认为这里的逻辑不应该由业务方来实现
    const fileRoleName = computed(() => {
      let roleName = '';
      if (previewHandler.currentApplyFile.value) {
        const fileRoles = previewHandler.currentApplyFile.value?.oldRoleIds;
        if (fileRoles.length > 1) {
          roleName = i18n_t('多种');
        } else {
          roleName = vm.$store.getters.rolesWithoutNoAccessMap.get(fileRoles[0])?.name || '';
        }
      }
      return roleName;
    });

    // TODO 后续要抽取在deskTop中统一实现，所以就尽可能不再污染handler来
    const isLogined = computed(() => vm.$store.getters.isLogined);
    watch(
      [isLogined, previewHandler.currentApplyFile],
      val => {
        if (val && previewHandler.currentApplyFile.value) {
          // 需要派发获取用户基本信息
          vm.$store.dispatch('getUserBaseInfo');
          vm.$store.dispatch('GetOrgInfo');
          // 来自协作群组
          if (vm.$route.query?.from === 'collaborationSpaceList') {
            const id = vm.$route.query?.teamId;
            const spaceOrgId = checkToNumber(vm.$route.query?.spaceOrgId);
            if (id && spaceOrgId) {
              vm.$store.dispatch(CollaborateGroupEvents.GET_GROUP_INFO, {
                id,
                spaceOrgId,
              });
            }
          }
        }
      },
      {
        immediate: true,
      },
    );
    return {
      isLogined,
      spaceId: headerHandler.spaceId,
      fileApplied,
      currentFileList,
      fileRoleName,
      fileName,
      envHelp,
      renderBar,
      currentApplyFile: previewHandler.currentApplyFile,
      isDocPreview: headerHandler.isDocPreview,
      isDocEdit: headerHandler.isDocEdit,
      isMeidaPreview: headerHandler.isMeidaPreview,
      renderAction: headerHandler.renderAction,
      dropDownActionList: headerHandler.dropDownActionList,
      requestPermissionVisible: headerHandler.requestPermissionVisible,
      onRequestPermission: () => {
        headerHandler.onRequestPermission();
      },
      goToIndexPage,
      onOperateEventProxy: headerHandler.onOperateEventProxy,
    };
  },
});
